import { getElements } from "./lib/get-element.module"
import Hammer from 'hammerjs';
import { $, $$ } from "./lib/$.module";
import { Splide } from "@splidejs/splide";

const defaultOptions = {
    
}

const globals = () => window.ceCarouselOptions

const _carousel = (element, options) => {
    const data = () => Object.fromEntries(
        Object.entries(element.dataset)
            .filter(([key, value]) => key.match(/carousel/))
            .map(([key, value]) => [key.replace(/carousel/, ''), value])
            .map(([key, value]) => [key.charAt(0).toLowerCase() + key.slice(1), value])
    )

    const _options = () => ({
        ...defaultOptions,
        ...globals(),
        ...options,
        ...data()
    })

    const _option = key => _options()[key]
    return (new Splide(element, _options())).mount()
}

const carousel = (element, options) => {
    const els = getElements(element)
    let h = []

    els.forEach((el) => {
        h.push(_carousel(el, options))
    })

    return h;
}


export { carousel }
